<template>
  <div>
    <table-card
      style="margin-bottom: 24px"
      header="Customer information"
      :table-data="tableData"
      :table-model="tableModel"
    />
    <table-card
      style="margin-bottom: 24px"
      header="Payment Insight"
      :table-data="tableData"
      :table-model="tableModel2"
    />
    <table-card
      style="margin-bottom: 24px"
      header="Event Filings"
      :table-data="tableData"
      :table-model="tableModel3"
    />
    <div class="financial-section">
    <table-card
      style="margin-bottom: 24px"
      header="Company Financials"
      :table-data="tableData"
      :table-model="tableModel4"
      :show-button="true"
      @button-click="handleSaveToFinancialReport"
    />
    </div>
    <table-card
      style="margin-bottom: 24px"
      header="Financial Strength Insight"
      :table-data="tableData"
      :table-model="tableModel5"
    />
    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="showDialog"
      width="35%"
      title="Save To Financial Report"
    >
      <el-checkbox-group v-model="checkList">
        <el-checkbox
          v-for="year in colYears"
          :key="year"
          :label="year"
        ></el-checkbox>
      </el-checkbox-group>
      <el-form
        size="small"
        class="submitform"
        :model="form"
        ref="ruleForm"
      >
        <el-form-item label="Financial Report Time" prop="fiscalYear">
          <el-date-picker
            v-model="form.fiscalYear"
            type="year"
            placeholder="Select Fiscal Year"
            value-format="yyyy"    style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="Period Ending" prop="periodEnding">
          <el-date-picker
            v-model="form.periodEnding"
            type="date"
            placeholder="Select Period Ending"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="Local Currency">
          <el-select v-model="form.localCurrency" clearable filterable  style="width: 100%">
            <el-option
              v-for="item in pendingData"
              :key="item.currency"
              :label="item.currencyName"
              :value="item.currency"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Exchange Date" v-if="form.localCurrency !== 'USD'">
          <el-date-picker
            type="date"            style="width: 100%"
            value-format="yyyy-MM-dd"
            v-model="form.exchangeDate"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="Exchange Rate(USD)"
          v-if="form.localCurrency !== 'USD'"
        >
          <el-input
            :disabled="true"
            v-model="form.exchangeRate"            style="width: 100%"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">Cancel</el-button>
        <el-button type="primary" @click="handleConfirm">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TableCard from './table-card'
import { getGlobalReportDetail,saveToFinancialByDbGlobal,getCurrenyRate } from '../../../api'
import { getCurrencyList } from '@/api'
export default {
  data() {
    const tableModel = [
      {
        label: 'D-U-N-S Number',
        key: 'dunsNumber',
      },
      {
        label: 'Currency',
        key: 'dbdufaultCurrency',
      },
      {
        label: 'Primary Name',
        key: 'primaryName',
      },
      {
        label: 'Trade Style Names',
        key: 'tradeStyleNames',
      },
      {
        label: 'Primary Address Street',
        key: 'primaryAddressStreet',
      },
      {
        label: 'Mailing Address Minor Town Name',
        key: 'mailingAddressMinorTownName',
      },
      {
        label: 'Primary Address Minor Town',
        key: 'primaryAddressMinorTown',
      },
      {
        label: 'Primary Address Region Name',
        key: 'primaryAddressRegionName',
      },
      {
        label: 'Primary Address County Name',
        key: 'primaryAddressCountyName',
      },
      {
        label: 'Organization Primary Address Postal Code',
        key: 'organizationPrimaryAddressPostalCode',
      },
      {
        label: 'ISO Alpha 2 Char Country Code',
        key: 'isoAlphaCharCountryCode',
      },
      {
        label: 'Telephone',
        key: 'telephone',
      },
      {
        label: 'Telephone Number International Dialing Code',
        key: 'telNumberInternationalDialingCode',
      },
      {
        label: 'Organization Identification Numbers',
        key: 'organizationIdentificationNumbers',
      },
      {
        label: 'Ownership Control Year',
        key: 'ownershipControlYear',
      },
      {
        label: 'Year Started',
        key: 'yearStart',
      },
      {
        label: 'Total Employees',
        key: 'totalEmployees',
      },
      {
        label: 'Incorporation Year',
        key: 'incorporationYear',
      },
      {
        label: 'Operating Status Start Date',
        key: 'operatingStatusStartDate',
      },
      {
        label: 'Number of Employees Value',
        key: 'numberOfEmployeesValue',
      },
      {
        label: 'Primary Industry Code USSicV4 Code',
        key: 'primaryIndustryCodeUssicv4Code',
      },
      {
        label: 'Industry Code USSicV4 Text',
        key: 'industryCodeUssicv4Text',
      },
      {
        label: 'Business Legal Structure',
        key: 'businessLegalStructureText',
      },
      {
        label: 'Activities Text',
        key: 'activitiesText',
      },
      {
        label: 'Operating Status Text',
        key: 'operatingStatusText',
      },
      {
        label: 'Banks',
        key: 'banks',
      },
      {
        label: 'Bank Name',
        key: 'bankName',
      },
      {
        label: 'Business Legal Structure Text',
        key: 'businessLegalStructureText',
      },
      {
        label: 'Ownership Control Type Text',
        key: 'ownershipControlTypeText',
      },
      {
        label: 'Is Small Business Indicator',
        key: 'isSmallBusinessIndicator',
      },
      {
        label: 'Family Tree Corporate Linkage Roles Played',
        key: 'familyTreeRolesPlayed',
      },
      {
        label: 'Family Tree Parent',
        key: 'familyTreeParent',
      },
      {
        label: 'Family Tree Global Ultimate',
        key: 'familyTreeGlobalUltimate',
      },
    ] // customer information table
    const tableModel2 = [
      {
        label: 'Business Trading Summary Paydex Score',
        key: 'businessTradingSummaryPaydexScore',
      },
      {
        label: 'Trade Norms Paydex Norms Lower Quartile',
        key: 'businessTradingSummaryPaydexScore',
      },
      {
        label: 'Trade Norms Paydex Norms Median',
        key: 'tradeNormsPaydexNormsMedianScore',
      },
      {
        label: 'Trade Norms Paydex Norms Upper Quartile',
        key: 'tradeNormsPaydexNormsUpperQuartileScore',
      },
      {
        label: 'Business Trading Summary Total Experiences Count',
        key: 'businessTradingSummaryTotalExperiencesCount',
      },
      {
        label: 'Block Status Reason',
        key: 'blockStatusReason',
      },
      {
        label: 'Business Trading Summary Payment Behavior Days',
        key: 'businessTradingSummaryPaymentBehaviorDays',
      },
      {
        label: 'Business Trading Summary Payment Behavior Description',
        key: 'businessTradingSummaryPaymentBehaviorDescription',
      },
      {
        label: 'Slow Experiences Amount',
        key: 'slowExperiencesAmount',
      },
    ] // payment insight table
    const tableModel3 = [
      {
        label: 'Financial Embarrassment Indicator',
        key: 'financialEmbarrassmentIndicator',
      },
      {
        label: 'Disaster Special Events Indicator',
        key: 'disasterSpecialEventsIndicator',
      },
      {
        label: 'Financial Events Indicator',
        key: 'financialEventsIndicator',
      },
      {
        label: 'Operational Special Events Indicator',
        key: 'operationalSpecialEventsIndicator',
      },
      {
        label: 'Significant Events Indicator',
        key: 'significantEventsIndicator',
      },
      {
        label: 'Open Suits Indicator',
        key: 'openSuitsIndicator',
      },
      {
        label: 'Claims Indicator',
        key: 'claimsIndicator',
      },
      {
        label: 'Open Secured Filings Indicator',
        key: 'openSecuredFilingsIndicator',
      },
    ] // event filings table
    const tableModel4 = [
      {
        label: 'Company Name',
        key: 'primaryName',
      },
      {
        label: 'Latest Financial Statement From Date',
        key: 'latestFinancialStatementFromDate',
      },
      {
        label: 'Latest Financial Statement To Date',
        key: 'latestFinancialStatementToDate',
      },
      {
        label: 'Latest Financials Audit Qualified Indicator',
        key: 'latestFinancialsAuditQualifiedIndicator',
      },
      {
        label: 'Latest Fiscal Financials Information Scope Text',
        key: 'latestFiscalFinancialsInformationScopeDescription',
      },
      {
        label: 'Latest Financials Currency',
        key: 'financialsUnitCode',
      },
      {
        label: 'Latest Financials Units',
        key: 'latestFinancialsUnits',
      },
      {
        label: 'Latest Financials Cash and Other Liquid Assets',
        key: 'latestFinancialsCashAndOtherLiquidAssets',
      },
      {
        label: 'Latest Financials Accounts Receivable',
        key: 'latestFinancialsAccountsReceivable',
      },
      {
        label: 'Latest Financials Accounts Payable',
        key: 'latestFinancialsAccountsPayable',
      },
      {
        label: 'Latest Financials Total Current Assets',
        key: 'latestFinancialsTotalCurrentAssets',
      },
      {
        label: 'Latest Financials Total Current Liabilities',
        key: 'latestFinancialsTotalCurrentLiabilities',
      },
      {
        label: 'Latest Financials Total Assets Amount',
        key: 'latestFinancialsTotalAssetsAmount',
      },
      {
        label: 'Latest Financials Total Liabilities',
        key: 'latestFinancialsTotalLiabilities',
      },
      {
        label: 'Latest Financials Total Equity Amount',
        key: 'latestFinancialsTotalEquityAmount',
      },
      {
        label: 'Latest Financials Tangible Networth Amount',
        key: 'latestFinancialsTangibleNetworthAmount',
      },
      {
        label: 'Latest Financial Sales Revenue',
        key: 'salesRevenueAmount',
      },
      {
        label: 'Latest Financials Net Income',
        key: 'latestFinancialsNetIncome',
      },
      {
        label: 'Latest Financials Inventory',
        key: 'latestFinancialsInventory',
      },
      {
        label: 'Latest Financials Total Fixed Assets',
        key: 'latestFinancialsTotalFixedAssets',
      },
      {
        label: 'Latest Financials Total Long Term Liabilities',
        key: 'latestFinancialsTotalLongTermLiabilities',
      },

      {
        label: 'Latest Fiscal Financials Issued Capital',
        key: 'latestFiscalFinancialsIssuedCapital',
      },
      {
        label: 'Latest Fiscal Financials Cost of Sales',
        key: 'latestFiscalFinancialsCostOfSales',
      },
      {
        label: 'Latest Fiscal Financials Intangible Assets',
        key: 'latestFiscalFinancialsIntangibleAssets',
      },
      {
        label: 'Latest Fiscal Financials Long-Term Debt',
        key: 'latestFiscalFinancialsLongTermDebt',
      },
      {
        label: 'Latest Fiscal Financials Operating Profit',
        key: 'latestFiscalFinancialsOperatingProfit',
      },
      {
        label: 'Latest Fiscal Financials Profit Before Taxes',
        key: 'latestFiscalFinancialsProfitBeforeTaxes',
      },
      {
        label: 'Latest Fiscal Financials Retained Earnings',
        key: 'latestFiscalFinancialsRetainedEarnings',
      },






    ] // company financials table
    const tableModel5 = [
      {
        label: 'D&B Assessment Standard Rating',
        key: 'dbassessmentStandardRating',
      },
      {
        label: 'D&B Assessment Delinquency Score National Percentile',
        key: 'dbassessmentDelinquencyScoreNationalPercentile',
      },
      {
        label: 'D&B Assessment Delinquency Score Class Score',
        key: 'dbassessmentDelinquencyScoreClassScore',
      },
      {
        label: 'D&B Assessment Failure Score National Percentile',
        key: 'dbassessmentFailureScoreNationalPercentile',
      },
      {
        label: 'D&B Assessment Failure Score Class Score',
        key: 'dbassessmentFailureScoreClassScore',
      },
      {
        label: 'D&B Assessment Credit Limit Recommendation Maximum',
        key: 'dbassessmentCreditLimitRecommendationMaximum',
      },
      {
        label: 'D&B Assessment Credit Limit Recommendation Maximum Currency',
        key: 'dbassessmentCreditLimitRecommendationMaximumCurrency',
      },
      {
        label: 'D&B Assessment Delinquency Score Date',
        key: 'dbassessmentDelinquencyScoreDate',
      },
      {
        label: 'D&B Assessment Failure Score Class Score Text',
        key: 'dbassessmentFailureScoreClassScoreText',
      },
      {
        label: 'D&B Assessment Delinquency Score Risk Incidence Percentage',
        key: 'dbassessmentDelinquencyScoreRiskIncidencePercentage',
      },
      {
        label: 'D&B Assessment Failure Score Risk Incidence Percentage',
        key: 'dbassessmentFailureScoreRiskIncidencePercentage',
      },
      {
        label: 'D&B Assessment Viability Rating',
        key: 'dbassessmentViabilityRatingRating',
      },
      {
        label: 'D&B Assessment Viability Rating Date',
        key: 'dbassessmentViabilityRatingRatingDate',
      },
    ] // financial strength insight
    return {
      tableData: {},
      tableModel: tableModel,
      tableModel2: tableModel2,
      tableModel3: tableModel3,
      tableModel4: tableModel4,
      tableModel5: tableModel5,
      showDialog: false,
      checkList: [],
      form: {
        localCurrency: '',
        exchangeDate: '',
        exchangeRate: '',
        fiscalYear: '',
        periodEnding: '',
      },
      pendingData: [],
      colYears: [],
    }
  },
  watch: {
    // 监听 localCurrency 和 exchangeDate 的变化
    'form.localCurrency': function (newVal) {
      if (newVal && this.form.exchangeDate) {
        this._fetchExchangeRate()
      }
    },
    'form.exchangeDate': function (newVal) {
      if (newVal && this.form.localCurrency) {
        this._fetchExchangeRate()
      }
    },
  },
  mounted() {
    this._getGlobalReportDetail()
  },
  methods: {
    async _getGlobalReportDetail() {
      try {
        const { id } = this.$store.state.bureauReportBasicInfo
        this.tableData = await getGlobalReportDetail(id)
        const filterCompanyFinancials = [
          'latestFinancialsCashAndOtherLiquidAssets',
          'latestFinancialsAccountsReceivable',
          'latestFinancialsAccountsPayable',
          'latestFinancialsTotalCurrentAssets',
          'latestFinancialsTotalCurrentLiabilities',
          'latestFinancialsTotalAssetsAmount',
          'latestFinancialsTotalLiabilities',
          'latestFinancialsTotalEquityAmount',
          'latestFinancialsTangibleNetworthAmount',
          'salesRevenueAmount',
          'latestFinancialsNetIncome',
          'dbassessmentCreditLimitRecommendationMaximum',
          'latestFinancialsInventory',
          'latestFinancialsTotalFixedAssets',
          'latestFinancialsTotalLongTermLiabilities',
          'latestFiscalFinancialsIssuedCapital',
          'latestFiscalFinancialsCostOfSales',
          'latestFiscalFinancialsIntangibleAssets',
          'latestFiscalFinancialsLongTermDebt',
          'latestFiscalFinancialsOperatingProfit',
          'latestFiscalFinancialsProfitBeforeTaxes',
          'latestFiscalFinancialsRetainedEarnings',
        ]
        filterCompanyFinancials.forEach(key => {
          const value = this.tableData[key]
          this.tableData[key] = this.$utils.formatAmount(value)
        })
      } catch (err) {
        console.error(err)
      }
    },
    handleSaveToFinancialReport() {
      this.showDialog = true
      this._getCurrenyList()
    },
    async _getCurrenyList() {
      this.pendingData = await getCurrencyList()
    },
    // 新增方法：获取汇率
    async _fetchExchangeRate() {
      if (!this.form.localCurrency || !this.form.exchangeDate) return

      try {
        const { rate } = await getCurrenyRate(this.form.exchangeDate, this.form.localCurrency)
        this.form.exchangeRate = rate
      } catch (err) {
        console.error('Failed to fetch exchange rate:', err)
        this.$message.error('Failed to fetch exchange rate')
      }
    },
    async handleConfirm() {
      try {
        const params = {
          bureauReportId : this.$store.state.bureauReportBasicInfo.id,
          exchangeDate : this.form.exchangeDate,
          localCurrency : this.form.localCurrency,
          rate : this.form.localCurrency === 'USD' ? '1' : this.form.exchangeRate,
          fiscalYear: this.form.fiscalYear,
          periodEnding: this.form.periodEnding,
        }
        await saveToFinancialByDbGlobal(params)
        this.$message.success('Success')
        this.showDialog = false
        this.checkList = []
      } catch (err) {
        console.error(err)
      }
    },
    handleCancel() {
      this.checkList = []
      this.form.exchangeDate = ''
      this.form.localCurrency = ''
      this.form.exchangeRate = ''
      this.showDialog = false
    },
  },
  components: {
    TableCard,
  },
}
</script>
<style scoped lang="scss">
/* 父组件样式 */
.financial-section {
  position: relative; /* 设置相对定位容器 */
}
</style>

